import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Modal, Text, InputField, Spinner } from '@getpingback/realeza';
import DataTable from '../../components/Table/DataTable';
import { getUsers, enrollUserInCourse, registerUser } from '../../services/teachable';
import { showAlert } from '../../store/ducks/alert';
import { TEACHABLE_COURSE_ID } from '../../config/environments';

const SaasEducation = () => {
  const dispatch = useDispatch();

  const dataTableHeaders = ['id', 'name', 'email'];

  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const [isEnrollModalOpen, setIsEnrollModalOpen] = useState(false);
  const [isAddUserAndEnrollModalOpen, setIsAddUserAndEnrollModalOpen] = useState(false);
  const [teachableUserEmail, setTeachableUserEmail] = useState('');
  const [teachableUserId, setTeachableUserId] = useState('');
  const [isLoadingPageData, setIsLoadingPageData] = useState(false);
  const [isLoadingTeachableReq, setIsLoadingTeachableReq] = useState(false);

  useEffect(() => {
    getTeachableUsers();
  }, [page]);

  const getTeachableUsers = async () => {
    try {
      setIsLoadingPageData(true);
      const { data } = await getUsers();

      setUsers(data.users);
      setPage(data.meta.page);
      setTotalItems(data.meta.total);
      setTotalPages(data.meta.number_of_pages);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingPageData(false);
    }
  };

  const addTeachableUser = async () => {
    try {
      setIsLoadingTeachableReq(true);
      const { data } = await registerUser(teachableUserEmail);
      dispatch(showAlert('success', 'User created ✅'));
      return data;
    } catch (error) {
      dispatch(showAlert('error', error.message));
    } finally {
      setIsLoadingTeachableReq(false);
      setIsAddUserModalOpen(false);
    }
  };

  const enrollTeachableUserInCourse = async userId => {
    try {
      setIsLoadingTeachableReq(true);
      const id = typeof userId === 'number' ? userId : teachableUserId;
      await enrollUserInCourse(id, TEACHABLE_COURSE_ID)
      dispatch(showAlert('success', 'User enrolled ✅'));
    } catch (error) {
      dispatch(showAlert('error', error.message));
    } finally {
      setIsLoadingTeachableReq(false);
      setIsEnrollModalOpen(false);
    }
  };

  const addAndEnrollTeachableUser = async () => {
    try {
      setIsLoadingTeachableReq(true);
      const user = await addTeachableUser();
      await enrollTeachableUserInCourse(user.id);
      dispatch(showAlert('success', 'User created and enrolled ✅'));
    } catch (error) {
      dispatch(showAlert('error', error.message));
    } finally {
      setIsLoadingTeachableReq(false);
      setIsAddUserAndEnrollModalOpen(false);
    }
  };

  if (isLoadingPageData) return <Spinner size="large" />;

  return (
    <>
      <div className="channels-container">
        <h1>SaaS Education Users ({totalItems})</h1>
        <Button onClick={() => setIsAddUserModalOpen(true)}>Add</Button>
        <Button onClick={() => setIsEnrollModalOpen(true)}>Enroll</Button>
        <Button onClick={() => setIsAddUserAndEnrollModalOpen(true)}>Add & Enroll</Button>
      </div>

      <DataTable
        head={dataTableHeaders}
        body={users}
        action={false}
        bodyColumn={dataTableHeaders}
        totalPages={totalPages}
        currentPage={page}
        setPageChange={setPage}
      />

      <Modal isOpen={isAddUserAndEnrollModalOpen} onClose={() => setIsAddUserAndEnrollModalOpen(false)}>
        <Text tag="h2" type="subtitle" size={20} weight="semibold">
          Add and enroll an user
        </Text>
        <Text>By adding an user email bellow, you will create and enroll in Pingback Course at Teachable</Text>

        <InputField
          style={{ marginTop: '16px' }}
          value={teachableUserEmail}
          onChange={e => setTeachableUserEmail(e.target.value)}
          placeholder="User email"
        />
        <Button
          fullWidth
          appearence="solid"
          mt="16px"
          isLoading={isLoadingTeachableReq}
          disabled={isLoadingTeachableReq}
          onClick={addAndEnrollTeachableUser}
        >
          Add & Enroll
        </Button>
      </Modal>

      <Modal isOpen={isAddUserModalOpen} onClose={() => setIsAddUserModalOpen(false)}>
        <Text tag="h2" type="subtitle" size={20} weight="semibold">
          Add an user
        </Text>
        <Text>By adding an user email bellow, you will create at Teachable</Text>

        <InputField
          style={{ marginTop: '16px' }}
          value={teachableUserEmail}
          onChange={e => setTeachableUserEmail(e.target.value)}
          placeholder="User email"
        />
        <Button
          fullWidth
          appearence="solid"
          mt="16px"
          isLoading={isLoadingTeachableReq}
          disabled={isLoadingTeachableReq}
          onClick={addTeachableUser}
        >
          Add
        </Button>
      </Modal>

      <Modal isOpen={isEnrollModalOpen} onClose={() => setIsEnrollModalOpen(false)}>
        <Text tag="h2" type="subtitle" size={20} weight="semibold">
          Enroll an user
        </Text>
        <Text>By adding an user id bellow, you will enroll in Pingback Course at Teachable</Text>

        <InputField
          style={{ marginTop: '16px' }}
          value={teachableUserId}
          onChange={e => setTeachableUserId(e.target.value)}
          placeholder="User id"
        />
        <Button
          fullWidth
          appearence="solid"
          mt="16px"
          isLoading={isLoadingTeachableReq}
          disabled={isLoadingTeachableReq}
          onClick={enrollTeachableUserInCourse}
        >
          Enroll
        </Button>
      </Modal>
    </>
  );
};

export default SaasEducation;
